import { render } from "./AccountList.vue?vue&type=template&id=5b1db31b&scoped=true"
import script from "./AccountList.vue?vue&type=script&lang=js"
export * from "./AccountList.vue?vue&type=script&lang=js"

import "./AccountList.vue?vue&type=style&index=0&id=5b1db31b&scoped=true&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1db31b"]])

export default __exports__